// inspired by react-router-dom and useHref hook
// https://github.com/remix-run/react-router/blob/cc4436c544300a09d9d95c5f733d3b00fd7d426f/packages/router/utils.ts#L1289
export function handleBasename(to: string, basename: string) {
  if (to === '/') return basename;
  return [basename, to].join('/').replace(/\/\/+/g, '/');
}
